import { Outlet } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { PageWrapper } from './PageWrapper';
import { useRef, type ReactNode } from "react";
import { Box, HStack, useDisclosure, VStack } from '@chakra-ui/react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { Toaster } from '../ui/toaster';

type LayoutProps = {
  children?: ReactNode;
};

// TODO: Move All animations and colors to ThemeContext
export const Layout = ({ children }: LayoutProps) => {
  const { open, onToggle, setOpen } = useDisclosure({ defaultOpen: false, });

  const HeaderHeight = "80px";
  // const DefaultSidebarWidth = 190;
  const DefaultSidebarWidth = 250;
  const CollapsedSidebarWidth = 60;

  const hoverTimeoutRef = useRef<NodeJS.Timeout | null>(null);


  const handleMouseEnter = () => {
    hoverTimeoutRef.current = setTimeout(() => {
      setOpen(true);
    }, 1000); // 3 seconds
  };

  const handleMouseLeave = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
      // hoverTimeoutRef.current = setTimeout(() => { // TODO: Need to think about this one.
      //   setOpen(false); // Makes sidebar close if user moves mouse out of it for more than {n} seconds
      // }, 4000);
    }
  };

  const sidebarWidth = open ? DefaultSidebarWidth : CollapsedSidebarWidth;

  return (
    <Box w="100%" h="100vh" overflow="hidden">
      <HStack align="start" gap={0} h="100%">
        {/* Sidebar */}
        <VStack
          h="100vh"
          w={`${sidebarWidth}px`}
          bg="bg.sidebar"
          // overflow="auto"
          // pointerEvents={open ? "auto" : "none"}
          position="relative"
          transition="width 0.3s ease"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <Sidebar open={open} onToggle={onToggle} />
        </VStack>

        {/* Main Content (Header + Page) */}
        <VStack
          flex="1"
          h="100vh"
          transition="margin-left 0.3s ease, width 0.3s ease"
          gap={0}
        >
          <Box
            w="100%"
            h={HeaderHeight}
            // boxShadow="sm"
            borderBottomWidth="1px"
            // position="fixed"
            top={0}
            left={0}
            pointerEvents="auto"
            zIndex={1}
            px={4}
            bg="bg.header"
          >
            <Header />
          </Box>

          <Box as="main" flex="1" w="100%" overflow="auto" px={4} pt={4}>
            <Toaster />
            <AnimatePresence mode="wait">
              <PageWrapper key={location.pathname}>
                {children ?? <Outlet />}
              </PageWrapper>
            </AnimatePresence>
          </Box>
        </VStack>
      </HStack>
    </Box>
  );
};